import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiWifi, FiMapPin, FiPhone, FiFacebook } = FiIcons;

const Footer = () => {
  return (
    <footer className="bg-slate-900 pt-20 pb-10 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Brand Col */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-6">
              <div className="bg-blue-600 p-2 rounded-lg">
                <SafeIcon icon={FiWifi} className="text-white text-xl" />
              </div>
              <span className="text-xl font-bold text-white tracking-tight">CRC<span className="text-blue-500">WiFi</span></span>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed mb-6">
              Clark-Ritchotte Communications provides premier business WiFi and networking solutions for companies throughout New York City.
            </p>
          </div>

          {/* Links Col */}
          <div>
            <h4 className="text-white font-semibold mb-6">Solutions</h4>
            <ul className="space-y-3">
              <li><a href="#" className="text-slate-400 hover:text-blue-400 text-sm transition-colors">Ubiquiti UniFi Installations</a></li>
              <li><a href="#" className="text-slate-400 hover:text-blue-400 text-sm transition-colors">Internet Cost Optimization</a></li>
              <li><a href="#" className="text-slate-400 hover:text-blue-400 text-sm transition-colors">Secure Business WiFi</a></li>
              <li><a href="#" className="text-slate-400 hover:text-blue-400 text-sm transition-colors">Branded Guest Networks</a></li>
              <li><a href="#" className="text-slate-400 hover:text-blue-400 text-sm transition-colors">Managed Network Services</a></li>
            </ul>
          </div>

          {/* Contact Col */}
          <div>
            <h4 className="text-white font-semibold mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-slate-400 text-sm">
                <SafeIcon icon={FiMapPin} className="text-blue-500 mt-1 flex-shrink-0" />
                <span>200 Broadway, Floor 3<br />New York, NY 10038</span>
              </li>
              <li className="flex items-center gap-3 text-slate-400 text-sm">
                <SafeIcon icon={FiPhone} className="text-blue-500 flex-shrink-0" />
                <span>(332) 378-0001</span>
              </li>
            </ul>
          </div>

          {/* SEO Text Block */}
          <div>
            <h4 className="text-white font-semibold mb-6">NYC Expertise</h4>
            <p className="text-slate-500 text-xs leading-relaxed">
              As a leading <strong>Ubiquiti Installer NYC</strong>, we specialize in <strong>Commercial WiFi NYC</strong> and comprehensive <strong>Business Networking NYC</strong>. Whether you need a simple <strong>Guest WiFi Setup NYC</strong>, complex multi-site <strong>Secure Business WiFi NYC</strong>, or full <strong>Managed Network Services NYC</strong>, Clark-Ritchotte Communications is your trusted local partner for all <strong>NYC Business WiFi Installation</strong> needs.
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            &copy; {new Date().getFullYear()} Clark-Ritchotte Communications. All rights reserved.
          </p>
          <div className="flex gap-6 items-center">
            {/* Facebook Icon Link */}
            <a 
              href="https://www.facebook.com/ClarkRitchotte" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-slate-500 hover:text-blue-500 transition-all transform hover:scale-110"
              aria-label="Follow us on Facebook"
            >
              <SafeIcon icon={FiFacebook} className="text-xl" />
            </a>
            <a href="#" className="text-slate-500 hover:text-white text-sm transition-colors">Privacy Policy</a>
            <a href="#" className="text-slate-500 hover:text-white text-sm transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;